module.exports = "https://coursera_assets.s3.amazonaws.com/images/abca2c446484c3db62f2ffb380ef2bbe.png";